
define('tpl!taoQtiItem/qtiCreator/tpl/toolbars/gap-create', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<div class=\"rgt tlb-button\" title=\""
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Create gap", options) : helperMissing.call(depth0, "__", "Create gap", options)))
    + "\" data-role=\"create-gap\">\n    <span class=\"icon-magicwand\"></span>\n</div>";
  return buffer;
  });
});

